import {
  // Button,
  Card,
  CardContent,
  IconButton,
  // IconButton,
  makeStyles,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
// import TableHead from "@saleor/components/TableHead";
// import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import StatusLabel from "@saleor/components/StatusLabel";
import TableCellAvatar, {
  AVATAR_MARGIN
} from "@saleor/components/TableCellAvatar";
import { InstagramDetails_instagram_products } from "@saleor/instagram/types/InstagramDetails";
import { maybe, renderCollection, stopPropagation } from "@saleor/misc";
import { ListActions, PageListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface InstagramProductsProps extends PageListProps, ListActions {
  products: InstagramDetails_instagram_products[];
  onProductUnassign?: (id: string, event: React.MouseEvent<any>) => void;
  reverseVisible: (data: InstagramDetails_instagram_products[]) => void;
}

const useStyles = makeStyles(
  theme => ({
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colName: {
      width: "auto"
    },
    colNameLabel: {
      marginLeft: AVATAR_MARGIN
    },
    colPublished: {
      width: "auto"
    },
    colType: {
      width: "auto"
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "InstagramProducts" }
);

const InstagramProducts: React.FC<InstagramProductsProps> = ({
  products,
  // selected,
  // disabled,
  // toggleAll,
  isChecked,
  onRowClick,
  reverseVisible
  // toggle,
  // toolbar,
  // onAdd
  // onProductUnassign
}) => {
  const intl = useIntl();
  // const numberOfColumns = 3
  const classes = useStyles();
  return (
    <>
      {products && (
        <Card>
          <CardTitle
            title={intl.formatMessage({
              defaultMessage: "Product",
              description: "Ins Product"
            })}
            // toolbar={
            //   <Button
            //     color={"primary"}
            //     onClick={onAdd}
            //     style={{ float: "right" }}
            //   >
            //     <FormattedMessage
            //       defaultMessage="Assign Product"
            //       description="button"
            //     />
            //   </Button>
            // }
          ></CardTitle>
          <CardContent style={{ maxHeight: "720px", overflowY: "scroll" }}>
            <ResponsiveTable>
              <TableHead
              // colSpan={numberOfColumns}
              // selected={selected}
              // disabled={disabled}
              // items={maybe(()=>products,undefined)}
              // toggleAll={toggleAll}
              // toolbar={toolbar}
              >
                <TableCell className={classes.colName}>
                  <span className={classes.colNameLabel}>
                    <FormattedMessage
                      defaultMessage="Name"
                      description="product name"
                    />
                  </span>
                </TableCell>
                <TableCell className={classes.colType}>
                  <FormattedMessage
                    defaultMessage="Type"
                    description="product type"
                  />
                </TableCell>
                <TableCell className={classes.colPublished}>
                  <FormattedMessage
                    defaultMessage="Published"
                    description="product is published"
                  />
                </TableCell>
                <TableCell className={classes.colActions}>
                  <FormattedMessage
                    defaultMessage="Visible"
                    description="productIns's visible"
                  />
                </TableCell>
              </TableHead>
              <TableFooter>
                <TableRow></TableRow>
              </TableFooter>
              <TableBody>
                {renderCollection(products, product => {
                  const isSelected = product
                    ? isChecked(product.product.id)
                    : false;
                  return (
                    <TableRow
                      className={classes.tableRow}
                      hover={!!product}
                      onClick={
                        !!product ? onRowClick(product.product.id) : undefined
                      }
                      key={product ? product.product.id : "skeleton"}
                      selected={isSelected}
                    >
                      {/* <TableCell padding="checkbox">
                            <Checkbox
                                checked={isSelected}
                                disabled={disabled}
                                disableClickPropagation
                                onChange={() => toggle(product.id)}
                            />
                        </TableCell> */}
                      <TableCellAvatar
                        className={classes.colName}
                        thumbnail={maybe(() => product.product.thumbnail.url)}
                      >
                        {maybe<React.ReactNode>(
                          () => product.product.name,
                          <Skeleton />
                        )}
                      </TableCellAvatar>
                      <TableCell className={classes.colType}>
                        {maybe<React.ReactNode>(
                          () => product.product.productType.name,
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell className={classes.colPublished}>
                        {maybe(
                          () => (
                            <StatusLabel
                              label={
                                product.product.isPublished
                                  ? intl.formatMessage({
                                      defaultMessage: "Published",
                                      description: "product is published"
                                    })
                                  : intl.formatMessage({
                                      defaultMessage: "Not published",
                                      description: "product is not published"
                                    })
                              }
                              status={
                                product.product.isPublished
                                  ? "success"
                                  : "error"
                              }
                            />
                          ),
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <IconButton
                          onClick={stopPropagation(() =>
                            reverseVisible([product])
                          )}
                        >
                          {maybe(() => product) ? (
                            product.visible ? (
                              <VisibilityIcon color={"primary"} />
                            ) : (
                              <VisibilityOffIcon color={"secondary"} />
                            )
                          ) : (
                            <Skeleton />
                          )}
                        </IconButton>
                      </TableCell>
                      {/* <TableCell className={classes.colActions}>
                        <IconButton
                          disabled={!product}
                          onClick={event =>
                            onProductUnassign(product.id, event)
                          }
                        >
                          <DeleteIcon color="primary" />
                        </IconButton>
                      </TableCell> */}
                    </TableRow>
                  );
                })}
              </TableBody>
            </ResponsiveTable>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default InstagramProducts;
